<template>
  <div class="settings-page">
    <div class="page-header mb-4">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
          <li class="breadcrumb-item active">الإعدادات</li>
        </ol>
      </nav>
      <h1 class="page-title">الإعدادات</h1>
    </div>

    <!-- Theme -->
    <div class="settings-section">
      <h2 class="section-title">المظهر</h2>
      <div class="theme-cards">
        <div
          class="theme-card"
          :class="{ active: currentTheme === 'dark' }"
          @click="selectTheme('dark')"
        >
          <div class="theme-preview theme-preview--dark">
            <div class="preview-navbar"></div>
            <div class="preview-body">
              <div class="preview-card"></div>
              <div class="preview-card"></div>
            </div>
          </div>
          <div class="theme-card__label">
            <i class="pi pi-moon me-2"></i>الوضع الداكن
            <i v-if="currentTheme === 'dark'" class="pi pi-check-circle ms-auto text-gold"></i>
          </div>
        </div>

        <div
          class="theme-card"
          :class="{ active: currentTheme === 'light' }"
          @click="selectTheme('light')"
        >
          <div class="theme-preview theme-preview--light">
            <div class="preview-navbar"></div>
            <div class="preview-body">
              <div class="preview-card"></div>
              <div class="preview-card"></div>
            </div>
          </div>
          <div class="theme-card__label">
            <i class="pi pi-sun me-2"></i>الوضع الفاتح
            <i v-if="currentTheme === 'light'" class="pi pi-check-circle ms-auto text-gold"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- Quick Links -->
    <div class="settings-section">
      <h2 class="section-title">إعدادات أخرى</h2>
      <div class="settings-links">
        <router-link to="/settings/whatsapp-templates" class="settings-link-card">
          <i class="pi pi-whatsapp"></i>
          <div>
            <div class="link-title">قوالب الواتساب</div>
            <div class="link-desc">إدارة رسائل الإشعارات التلقائية</div>
          </div>
          <i class="pi pi-chevron-left ms-auto"></i>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SettingsIndex',
  computed: {
    currentTheme() {
      return this.$store.getters['currentTheme'];
    }
  },
  methods: {
    selectTheme(theme) {
      this.$store.dispatch('setTheme', theme);
    }
  }
}
</script>

<style scoped>
.settings-page {
  padding: 1.5rem;
  max-width: 800px;
}

.page-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--text-primary);
}

.settings-section {
  background: var(--surface-card);
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: var(--shadow-md);
}

.section-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--gold-primary);
  margin-bottom: 1.25rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--border-subtle);
}

/* Theme Cards */
.theme-cards {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.theme-card {
  flex: 1;
  min-width: 180px;
  border: 2px solid var(--border-subtle);
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.theme-card:hover {
  border-color: var(--gold-primary);
  box-shadow: 0 0 0 2px rgba(247, 180, 36, 0.2);
}

.theme-card.active {
  border-color: var(--gold-primary);
  box-shadow: 0 0 0 3px rgba(247, 180, 36, 0.3);
}

.theme-preview {
  height: 90px;
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.theme-preview--dark {
  background: #0D0D0D;
}

.theme-preview--light {
  background: #F5F5F5;
}

.preview-navbar {
  height: 14px;
  border-radius: 4px;
}
.theme-preview--dark .preview-navbar { background: #1A1A1A; }
.theme-preview--light .preview-navbar { background: #FFFFFF; }

.preview-body {
  display: flex;
  gap: 5px;
  flex: 1;
}

.preview-card {
  flex: 1;
  border-radius: 4px;
}
.theme-preview--dark .preview-card { background: #1E1E1E; }
.theme-preview--light .preview-card { background: #FFFFFF; }

.theme-card__label {
  padding: 0.6rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-primary);
  background: var(--surface-raised);
  display: flex;
  align-items: center;
}

.text-gold { color: var(--gold-primary); }

/* Settings Links */
.settings-links {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.settings-link-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: var(--surface-raised);
  border-radius: 10px;
  text-decoration: none;
  color: var(--text-primary);
  border: 1px solid var(--border-subtle);
  transition: border-color 0.2s, background 0.2s;
}

.settings-link-card:hover {
  border-color: var(--gold-primary);
  background: var(--surface-hover);
  color: var(--text-primary);
}

.settings-link-card > .pi:first-child {
  font-size: 1.4rem;
  color: var(--gold-primary);
}

.link-title {
  font-weight: 600;
  font-size: 0.9rem;
}

.link-desc {
  font-size: 0.78rem;
  color: var(--text-secondary);
  margin-top: 2px;
}
</style>
